// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__11OWv","content":"styles_content__3JX_A","checkbox":"styles_checkbox__1_N04","checkboxLabel":"styles_checkboxLabel__2JUnW"};